module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/045-andorra-8ed2454a5597cb341059cb8499978200.svg";